/**
 * Per-recipient messages for a drop (paginated). Powers the Tool tab's
 * message-level drill-down.
 * For Media Devoted | Created By Ciro Autiero
 */

import { keepPreviousData, useQuery } from '@tanstack/react-query';

import api from '@/services/api';

import type { ToolMessagesPage } from './tool-stats.types';

export interface ToolDropMessagesParams {
  page?: number;
  limit?: number;
}

export function useToolDropMessages(
  uniqueId: string,
  params: ToolDropMessagesParams = {},
  enabled = true,
) {
  const { page = 1, limit = 100 } = params;
  return useQuery({
    queryKey: ['smswiser', 'tool-stats', 'messages', uniqueId, page, limit],
    enabled: enabled && !!uniqueId,
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const res = await api.get<{ data: ToolMessagesPage }>(
        `/smswiser/tool-stats/drops/${encodeURIComponent(uniqueId)}/messages`,
        { params: { page, limit } },
      );
      return res.data.data;
    },
    staleTime: 60_000,
  });
}
